import * as React from 'react';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import {
  Box,
  Button,
  Typography,
  Grid,
  Container,
} from "@mui/material";
import Slider from '@mui/material/Slider';
import { TbStethoscope } from "react-icons/tb";
import { ImLab } from "react-icons/im";
import { MdOutlineMedicalServices } from "react-icons/md";
import banner1 from '../assests/banner1.png';
import { useCategoryStore } from '../store/useCategoryStore';
import { useProductStore } from '../store/useProductStore';
import { useNavigate } from 'react-router-dom';


const CategoryListCard = ({ setIsVisible }) => {

  const listMenu = {
    fontSize: '14px',
    lineHeight: '28.8px',
    fontWeight: '400',
    fontFamily: `"Lato", sans-serif`,
    color: 'rgba(0, 0, 0, 0.51)',
    border: '1px solid rgba(0, 0, 0, 0.11)',
    padding: '5px 10px',
    borderRadius: '5px',
    display: 'flex',
    alignItems: 'center',
    marginTop: '10px',
    '& svg': {
      marginRight: '15px',
      fontSize: '25px',
      color: "#008BFF",
    },
  }

  const { loading, category, setSelectedCategory } = useCategoryStore()
  const { getAllProduct, setReload } = useProductStore()
  const navigate = useNavigate()

  const handleSelectCategory = async (id, name) => {
    setSelectedCategory(id, name)
    await getAllProduct(1, 10, id, 'category')
    navigate("/shop")
    setReload(false)
    // navigate(`/lifeline/shop?reload=false`);
    setIsVisible(false)
  }


  return (
    <Box
      sx={{
        width: "100%",
        backgroundColor: "#fff",
        borderRadius: "15px",
        border: "1px solid #ECECEC",
        boxShadow: "5px 5px 15px 0px #0000000D",
        "& .filterInner": {
          padding: "25px",
        },
      }}
    >
      <div className="filterInner">
        <Typography
          sx={{
            fontSize: "24px",
            lineHeight: "28.8px",
            fontWeight: "700",
            fontFamily: `"Quicksand", sans-serif`,
            color: "#253D4E",
            paddingBottom: "16px",
            borderBottom: "1px solid #ECECEC",
            position: "relative",
            "&::before": {
              content: `""`,
              width: "80px",
              height: "2px",
              background: "#008BFF",
              position: "absolute",
              left: "0",
              bottom: "0",
            },
          }}
        >
          Category
        </Typography>
        <Box sx={{ width: "100%" }} style={{ cursor: "pointer" }}>
          {
            (category || []).map((ele, index) => (
              <Typography sx={listMenu}
                onClick={() => handleSelectCategory(ele._id, ele?.name)}
                key={index}
              >
                {/* <img src={ele?.images} alt=""
                  style={{
                    "width": "40px",
                    "height": "40px",
                    "marginRight": "5px"
                  }} /> */}
                {ele?.name}
              </Typography>
            ))
          }

        </Box>
      </div>
    </Box>
  );
}

export default CategoryListCard;